import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./map.module.css";
import Spinner from "../Spinner";
import { useDispatch } from "react-redux";
import { FaLocationCrosshairs } from "react-icons/fa6";
import { Card } from "react-bootstrap";
import { BiBox } from "react-icons/bi";

export default function PositionsMap(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const mapContainerRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const infoWindowRef = useRef(null);
  const [mapLoading, setMapLoading] = useState(false);
  

  
  const handleActiveTab = (tabName) => {
    dispatch({ type: "activeTab", value: tabName });
    props.chooseDisplay(tabName, 0);
  };
  
  const getMarkerContent = (data) => {
    const formatDateTimeToBR = (dateString) => {
      const date = new Date(dateString);
      return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    };
    
    return `
      <span className="title-infoPosition" style='font-weight:bold;'>Informação Registrada</span><br/>
      <table>
        <tr><td><b>Data/Hora:</b></td><td>${formatDateTimeToBR(data.generationDate)}</td></tr>
        <tr><td><b>Ignição:</b></td><td>${data.ignition}</td></tr>
        <tr><td><b>Velocidade:</b></td><td>${data.speed} Km/h</td></tr>
        <tr><td><b>Distância Percorrida:</b></td><td>0 Km</td></tr>
      </table>
    `;
  };

  const setMarkers = (map, coordinates, positions) => {
    const bounds = new window.google.maps.LatLngBounds();

    coordinates.forEach((coord, index) => {
      const position = positions[index];
      let fillColor = "#007BFF";
      if (position.speedStatusDescription?.includes("atraso")) fillColor = "#007BFF";
      else if (position.ignition?.toLowerCase() === "desligado") fillColor = "#007BFF";
      else if (position.ignition?.toLowerCase() === "ligado" && position.speed === 0) fillColor = "#007BFF";

      const marker = new window.google.maps.Marker({
        position: coord,
        map,
        icon: {
          path: window.google.maps.SymbolPath.CIRCLE,
          scale: 6,
          fillColor,
          fillOpacity: 1,
          strokeColor: "white",
          strokeWeight: 1,
        },
        label: index === 0 ? "F" : index === positions.length - 1 ? "I" : undefined,
        title: index === 0 ? "Fim" : index === positions.length - 1 ? "Início" : undefined,
      });

      marker.addListener("click", () => {
        if (infoWindowRef.current) infoWindowRef.current.close();
        infoWindowRef.current = new window.google.maps.InfoWindow({
          content: getMarkerContent(position),
        });
        infoWindowRef.current.open({ anchor: marker, map });
      });

      bounds.extend(coord);
    });

    map.fitBounds(bounds);
  };

  const createMap = () => {
    
    if (!mapContainerRef.current || !window.google?.maps || !props.diaryPositions?.length) return;

    const coordinates = props.diaryPositions
      .map((item) => {
        const lat = parseFloat(item.latitude?.toString().replace(",", "."));
        const lng = parseFloat(item.longitude?.toString().replace(",", "."));
        return !isNaN(lat) && !isNaN(lng) && lat !== lng ? new window.google.maps.LatLng(lat, lng) : null;
      })
      .filter(Boolean);

    if (coordinates.length === 0) return;

    const center = coordinates[Math.floor(coordinates.length / 2)];

    if (!mapInstanceRef.current) {
      mapInstanceRef.current = new window.google.maps.Map(mapContainerRef.current, {
        center,
        zoom: 14,
        streetViewControl: false,
      });
    }

    const map = mapInstanceRef.current;

    const speedStatusList = props.diaryPositions
    .map((item) => item.speedStatus)
    .filter(Boolean);


// Itera sobre as coordenadas para criar uma Polyline por segmento
coordinates.forEach((coord, index) => {
  
  if (index === 0) return;

  const speed = speedStatusList[index - 1];

  // Define a cor com base no valor de speed
  let strokeColor;
  if (speed === "1" || speed === "2") {
    strokeColor = "red";
  } else if (speed === "3" || speed === "4") {
    strokeColor = "orange";
  } else {
    strokeColor = "blue"; // Padrão para "0" ou outros valores
  }

  new window.google.maps.Polyline({
    path: [coordinates[index - 1], coordinates[index]], 
    geodesic: true,
    strokeColor: strokeColor, 
    strokeWeight: 5,
    strokeOpacity: 1,
    clickable: true,
    icons: [{
      icon: {
        path: "M -1.5 -1 L -1 0 L -1 -2 M -0.5 -1 L -1 0",
        strokeColor: "black",
        strokeOpacity: 1,
        strokeWeight: 2,
        scale: 6,
      }}],
    map: map, 
  });
});
    // const polyline = new window.google.maps.Polyline({
    //   path: coordinates,
    //   geodesic: true,
    //   strokeWeight: 5,
    //   strokeColor: "",
    //   clickable: true,
    //   editable: false,
    //   zIndex: 1,
    //   icons: [{
    //     icon: {
    //       path: "M -1.5 -1 L -1 0 L -1 -2 M -0.5 -1 L -1 0",
    //       strokeColor: "black",
    //       strokeOpacity: 1,
    //       strokeWeight: 2,
    //       scale: 6,
    //     },
    //     repeat: "100px",
    //   }],
    //   map,
    // });

    setMarkers(map, coordinates, props.diaryPositions);
  };

  useEffect(() => {
    if (props.activeTab === "positions" && props.diaryPositions?.length > 0) {
      setMapLoading(true);
      setTimeout(() => {
        createMap();
        setMapLoading(false);
        
        const map = mapInstanceRef.current;
        const positions = props.diaryPositions;
        if (props.handleClick === true && props.selectedIndex !== null) {
          setMapLoading(false);

  
          const itemSelecionado = positions[props.selectedIndex]; // 👈 usa o índice
  
          const lat = parseFloat(itemSelecionado.latitude?.toString().replace(",", "."));
          const lng = parseFloat(itemSelecionado.longitude?.toString().replace(",", "."));
  
          if (!isNaN(lat) && !isNaN(lng)) {
            
            const position = new window.google.maps.LatLng(lat, lng);
            
            if(map){
              map.setZoom(18);
              map.panTo(position);
            } 

            const content = getMarkerContent(itemSelecionado);
            if (infoWindowRef.current) infoWindowRef.current.close();

            infoWindowRef.current = new window.google.maps.InfoWindow({
              content,
              position,
            });
            infoWindowRef.current.open(map);
          }
        setMapLoading(false);

  
        }
        setMapLoading(false);

      }, 200);
      setMapLoading(false);

    }
  }, [props.activeTab, props.diaryPositions, props.handleClick, props.selectedIndex]);
  
  const hasRun = useRef(false);

  useEffect(() => {
    
    if (!hasRun.current && props.activeTab === "positions") {
      props.onHandled?.();
      hasRun.current = true;
    }
  }, [props.activeTab]);
  
  return (
    <>
      {mapLoading && <Spinner />}

      <div className={styles.mapContainerWrapper}>
        <button
          className={styles.floatingButtonPositions}
          onClick={() => handleActiveTab("positions")}
          style={props.activeTab === "positions" ? { display: "none" } : {}}
        >
          <FaLocationCrosshairs size={18} />
          Posições
        </button>

        {props.diaryPositions?.length ? (
          <div
            id="map_track"
            ref={mapContainerRef}
            className={styles.positionsMap}
          />
          
        ): (
          <div className="alert alert-info" style={{ margin: "20px", textAlign: "center" }}>
            <BiBox size={50} style={{ marginBottom: "10px", opacity: 0.5 }} />
            <div>{t("COMMON.NO_DATA_FOUND")}</div>
          </div>
        )}

        </div>
    </>
  );
}
